import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, Teleport as _Teleport } from "vue"

const _hoisted_1 = { ref: "el" }
const _hoisted_2 = {
  key: 0,
  class: "hidden lg:mb-36 lg:flex lg:space-x-4"
}
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "block text-6xl-quote-long font-bold" }
const _hoisted_5 = {
  key: 0,
  class: "block text-sm text-gray-400"
}
const _hoisted_6 = {
  key: 1,
  class: "mb-3 block lg:text-right"
}
const _hoisted_7 = { class: "lg:grid lg:grid-cols-4 lg:gap-x-4" }
const _hoisted_8 = { class: "hidden lg:row-start-1 lg:block lg:pr-6" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = {
  key: 0,
  class: "absolute -right-2 top-1 block h-1.5 w-1.5 rounded-full bg-cyan"
}
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "mb-6 space-y-2" }
const _hoisted_13 = ["disabled", "checked", "value"]
const _hoisted_14 = { class: "ml-2 inline-block" }
const _hoisted_15 = { class: "grid grid-cols-2 gap-x-4 gap-y-8 lg:col-span-3 lg:row-start-1 lg:grid-cols-3 lg:gap-y-16" }
const _hoisted_16 = ["href"]
const _hoisted_17 = { class: "relative h-0 w-full overflow-hidden bg-gray-100 pt-1/1" }
const _hoisted_18 = ["src", "alt"]
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "mb-4 mt-8 h-0.5 w-8 bg-black" }, null, -1)
const _hoisted_20 = ["innerHTML"]
const _hoisted_21 = ["innerHTML"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "absolute left-0 -bottom-px h-0.5 w-full origin-left scale-x-0 border-b-2 border-gray-500 transition-transform duration-500 group-hover:scale-x-100" }, null, -1)
const _hoisted_23 = {
  key: 2,
  class: "lg:grid lg:grid-cols-4 lg:gap-x-4"
}
const _hoisted_24 = { class: "flex lg:col-span-3 lg:col-start-2" }
const _hoisted_25 = {
  key: 0,
  class: "font-light"
}
const _hoisted_26 = {
  key: 4,
  class: "invisible"
}
const _hoisted_27 = {
  key: 0,
  class: "fixed left-0 top-0 z-50 flex h-screen w-screen bg-gray-500 bg-opacity-75 pt-12 lg:hidden"
}
const _hoisted_28 = { class: "scrollbar-hide flex w-full flex-col overflow-y-auto overflow-x-hidden bg-white px-4 py-6" }
const _hoisted_29 = { class: "flex grow flex-col" }
const _hoisted_30 = { class: "relative grow" }
const _hoisted_31 = { class: "scrollbar-hide absolute h-full w-full overflow-y-auto overflow-x-hidden" }
const _hoisted_32 = { class: "relative" }
const _hoisted_33 = {
  key: 0,
  class: "absolute -right-2 top-1 block h-1.5 w-1.5 rounded-full bg-cyan"
}
const _hoisted_34 = ["onClick"]
const _hoisted_35 = { class: "mb-6 space-y-2" }
const _hoisted_36 = ["disabled", "checked", "value"]
const _hoisted_37 = { class: "ml-2 inline-block" }
const _hoisted_38 = { class: "button button-primary mt-6 w-full" }
const _hoisted_39 = {
  key: 0,
  class: "font-light"
}
const _hoisted_40 = { key: 0 }
const _hoisted_41 = {
  key: 0,
  class: "font-light"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_biz_icon = _resolveComponent("biz-icon")!
  const _component_biz_accordion = _resolveComponent("biz-accordion")!
  const _component_loading_spinner = _resolveComponent("loading-spinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.heroFilter && !_ctx.loading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.heroFilter.categories, (category) => {
              return (_openBlock(), _createElementBlock("div", {
                key: category.categoryKey,
                onClick: ($event: any) => (_ctx.selectHeroFilter(category)),
                class: _normalizeClass([{
                    'pointer-events-none text-gray-400':
                        (_ctx.heroActive && !_ctx.isSelected(category.categoryKey)) ||
                        (_ctx.result && _ctx.result.filters[category.categoryId] === 0)
                }, "group relative flex-1 cursor-pointer border-t-2 border-gray-100 pt-4"])
              }, [
                _createElementVNode("span", _hoisted_4, _toDisplayString(category.name), 1),
                (_ctx.result)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.result.filters[category.categoryId]) + " " + _toDisplayString(_ctx.result.filters[category.categoryId] === 1 ? _ctx.productLabel : _ctx.productsLabel), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: _normalizeClass([[_ctx.isSelected(category.categoryKey) ? 'scale-x-100' : 'scale-x-0'], "absolute -top-px left-0 h-0.5 w-full origin-left bg-gray-500 transition-transform group-hover:scale-x-100"])
                }, null, 2)
              ], 10, _hoisted_3))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        class: "button button-secondary mb-8 block flex items-center lg:hidden",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMobileFilters && _ctx.toggleMobileFilters(...args)))
      }, [
        _createTextVNode(_toDisplayString(_ctx.showFilterLabel) + " ", 1),
        _createVNode(_component_biz_icon, {
          name: "sliders",
          class: "ml-2 h-4 w-4 fill-current"
        })
      ]),
      (_ctx.result)
        ? (_openBlock(), _createElementBlock("b", _hoisted_6, _toDisplayString(_ctx.result.total) + " " + _toDisplayString(_ctx.result.total === 1 ? _ctx.resultLabel : _ctx.resultsLabel), 1))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.availableFilters, (filter) => {
            return (_openBlock(), _createBlock(_component_biz_accordion, {
              key: filter.filterKey,
              group: _ctx.uuid,
              disabled: !_ctx.hasEnabledCategories(filter)
            }, {
              title: _withCtx(({ open }) => [
                _createElementVNode("div", {
                  class: _normalizeClass(["py-6 text-left font-bold text-gray-400 transition-colors lg:text-lg", {
                                'text-gray-500': open || _ctx.selectedSubcategories(filter).length
                            }])
                }, [
                  _createElementVNode("span", _hoisted_9, [
                    _createTextVNode(_toDisplayString(filter.name) + " ", 1),
                    (_ctx.selectedSubcategories(filter).length)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_10))
                      : _createCommentVNode("", true)
                  ]),
                  (!open)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedSubcategories(filter), (cat) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: `rm#${cat.categoryId}`,
                          onClick: _withModifiers(($event: any) => (_ctx.removeCategory(cat)), ["stop"]),
                          class: "flex items-center text-xs font-normal"
                        }, [
                          _createVNode(_component_biz_icon, {
                            name: "close",
                            class: "mr-2 h-2 w-2"
                          }),
                          _createTextVNode(" " + _toDisplayString(cat.name), 1)
                        ], 8, _hoisted_11))
                      }), 128))
                    : _createCommentVNode("", true)
                ], 2)
              ]),
              default: _withCtx(() => [
                _createElementVNode("ul", _hoisted_12, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.categories, (cat) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: cat.categoryId
                    }, [
                      _createElementVNode("label", {
                        class: _normalizeClass(["checkbox checkbox-black flex items-center", {
                                    'checkbox-disabled': _ctx.isCategoryDisabled(filter, cat)
                                }])
                      }, [
                        _createElementVNode("input", {
                          type: "checkbox",
                          class: "w-auto",
                          disabled: _ctx.isCategoryDisabled(filter, cat),
                          onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.selectFilter && _ctx.selectFilter(...args))),
                          checked: 
                                        _ctx.selectedFilters.some(x => x.includes(cat.categoryKey))
                                    ,
                          value: cat.categoryKey
                        }, null, 40, _hoisted_13),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(cat.name), 1)
                      ], 2)
                    ]))
                  }), 128))
                ])
              ]),
              _: 2
            }, 1032, ["group", "disabled"]))
          }), 128)),
          (!_ctx.loading && _ctx.products.length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button button-text ml-auto mt-8 block pb-0 opacity-50 transition-opacity hover:opacity-100",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.clearFilters(false)))
              }, _toDisplayString(_ctx.removeAllLabel), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_15, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.products, (product) => {
            return (_openBlock(), _createElementBlock("a", {
              key: product.id,
              href: product.link,
              class: "group relative block border-b border-gray-100 pb-4"
            }, [
              _createElementVNode("div", _hoisted_17, [
                (product.image)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: product.image,
                      alt: product.imageAlt,
                      class: "absolute left-0 top-0 h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-105"
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_19,
              _createElementVNode("b", {
                class: "mb-3 hyphens-auto",
                innerHTML: product.title
              }, null, 8, _hoisted_20),
              _createElementVNode("div", {
                class: "font-light text-gray-400 line-clamp-2 hyphens-auto lg:pr-8",
                innerHTML: product.text
              }, null, 8, _hoisted_21),
              _hoisted_22
            ], 8, _hoisted_16))
          }), 128))
        ])
      ]),
      (!_ctx.loading && this.result && this.result.total > this.products.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
            _createElementVNode("div", _hoisted_24, [
              _createElementVNode("button", {
                class: "button button-secundary mx-auto mt-6",
                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.loadMore && _ctx.loadMore(...args)))
              }, [
                (_ctx.result)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(_ctx.loadMoreLabel), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.loading)
        ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 3 }))
        : _createCommentVNode("", true),
      (!_ctx.ready)
        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
            _renderSlot(_ctx.$slots, "default")
          ]))
        : _createCommentVNode("", true)
    ], 512),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, {
        mode: "out-in",
        "enter-active-class": "duration-300 ease-out",
        "enter-from-class": "opacity-0",
        "enter-to-class": "opacity-100",
        "leave-active-class": "duration-300 ease-in",
        "leave-from-class": "opacity-100",
        "leave-to-class": "opacity-0"
      }, {
        default: _withCtx(() => [
          (_ctx.mobileFiltersOpen)
            ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                _createVNode(_Transition, {
                  "enter-active-class": "duration-300 delay-300 ease-out",
                  "enter-from-class": "translate-y-full",
                  "enter-to-class": "translate-y-0",
                  "leave-active-class": "duration-300 ease-in",
                  "leave-from-class": "translate-y-0",
                  "leave-to-class": "translate-y-full"
                }, {
                  default: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_28, [
                      _createElementVNode("button", {
                        class: "ml-auto mb-4 block h-5 w-5",
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.toggleMobileFilters(false)))
                      }, [
                        _createVNode(_component_biz_icon, {
                          name: "close",
                          class: "h-full w-full"
                        })
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _createElementVNode("div", _hoisted_30, [
                          _createElementVNode("div", _hoisted_31, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allFilters, (filter) => {
                              return (_openBlock(), _createBlock(_component_biz_accordion, {
                                key: filter.filterKey,
                                "big-icon": "",
                                disabled: !_ctx.hasEnabledCategories(filter, true),
                                group: _ctx.uuid
                              }, {
                                title: _withCtx(({ open }) => [
                                  _createElementVNode("div", {
                                    class: _normalizeClass(["flex flex-col items-start py-6 text-lg font-bold text-gray-400 transition-colors", { 'text-gray-500': open }])
                                  }, [
                                    _createElementVNode("span", _hoisted_32, [
                                      _createTextVNode(_toDisplayString(filter.name) + " ", 1),
                                      (
                                                            _ctx.selectedSubcategories(filter, true)
                                                                .length
                                                        )
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_33))
                                        : _createCommentVNode("", true)
                                    ]),
                                    (!open)
                                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.selectedSubcategories(
                                                            filter,
                                                            true
                                                        ), (cat) => {
                                          return (_openBlock(), _createElementBlock("button", {
                                            key: `rm#${cat.categoryId}`,
                                            onClick: _withModifiers(($event: any) => (_ctx.removeCategory(cat, true)), ["stop"]),
                                            class: "flex items-center text-xs font-normal"
                                          }, [
                                            _createVNode(_component_biz_icon, {
                                              name: "close",
                                              class: "mr-2 h-2 w-2"
                                            }),
                                            _createTextVNode(" " + _toDisplayString(cat.name), 1)
                                          ], 8, _hoisted_34))
                                        }), 128))
                                      : _createCommentVNode("", true)
                                  ], 2)
                                ]),
                                default: _withCtx(() => [
                                  _createElementVNode("ul", _hoisted_35, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filter.categories, (cat) => {
                                      return (_openBlock(), _createElementBlock("li", {
                                        key: cat.categoryId
                                      }, [
                                        _createElementVNode("label", {
                                          class: _normalizeClass(["checkbox checkbox-black flex items-center", {
                                                        'checkbox-disabled': _ctx.isCategoryDisabled(
                                                            filter,
                                                            cat,
                                                            true
                                                        )
                                                    }])
                                        }, [
                                          _createElementVNode("input", {
                                            type: "checkbox",
                                            class: "w-auto",
                                            disabled: 
                                                            _ctx.isCategoryDisabled(filter, cat, true)
                                                        ,
                                            onInput: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.selectMobileFilter && _ctx.selectMobileFilter(...args))),
                                            checked: 
                                                            _ctx.selectedFiltersBuffer.some(x =>
                                                                x.includes(cat.categoryKey)
                                                            )
                                                        ,
                                            value: cat.categoryKey
                                          }, null, 40, _hoisted_36),
                                          _createElementVNode("span", _hoisted_37, _toDisplayString(cat.name), 1)
                                        ], 2)
                                      ]))
                                    }), 128))
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["disabled", "group"]))
                            }), 128))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createElementVNode("button", _hoisted_38, [
                            (_ctx.result)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_39, _toDisplayString(_ctx.loadMoreLabel), 1))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (!_ctx.loading && _ctx.products.length)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                              _createElementVNode("button", {
                                class: "button button-primary mt-6 w-full",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.toggleMobileFilters(true)))
                              }, [
                                _createTextVNode(_toDisplayString(_ctx.showResultsLabel) + " ", 1),
                                (_ctx.result)
                                  ? (_openBlock(), _createElementBlock("span", _hoisted_41, "(" + _toDisplayString(_ctx.result.total) + ")", 1))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("button", {
                                class: "button button-text mx-auto mt-2.5 block pb-0",
                                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.clearFilters(true)))
                              }, _toDisplayString(_ctx.removeAllLabel), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ], 512), [
                      [_vShow, _ctx.mobileFiltersInnerOpen]
                    ])
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 64))
}